import { render, staticRenderFns } from "./lianchuang.vue?vue&type=template&id=bd5d0c34&scoped=true"
import script from "./lianchuang.vue?vue&type=script&lang=js"
export * from "./lianchuang.vue?vue&type=script&lang=js"
import style0 from "./lianchuang.vue?vue&type=style&index=0&id=bd5d0c34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5d0c34",
  null
  
)

export default component.exports